import PropTypes from 'prop-types'
import React from 'react'
import Sidebar from 'react-sidebar'

const mediaQueryList = window.matchMedia('(min-width:800px)')

class SaxsSideBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      sidebarDocked: mediaQueryList.matches,
      sidebarOpen: true,
    }

    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
    this.mediaQueryChanged = this.mediaQueryChanged.bind(this)
  }

  render() {
    return (
      <Sidebar
        styles={{
          root: {
            position: 'fixed',
            top: 100,
            zIndex: 1,
          },
          sidebar: { marginBottom: '53px', backgroundColor: '#ffffff', width: '250px' },
          content: { marginBottom: '53px' },
        }}
        sidebar={this.props.sideBarComponent}
        open={this.state.sidebarOpen}
        docked={this.state.sidebarDocked}
        onSetOpen={this.onSetSidebarOpen}
        shadow
        touch
      >
        {this.props.children}
      </Sidebar>
    )
  }
  // FIXME bmo 20210210
  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    mediaQueryList.addListener(this.mediaQueryChanged)
  }

  componentWillUnmount() {
    mediaQueryList.removeListener(this.mediaQueryChanged)
  }

  mediaQueryChanged() {
    this.setState({ sidebarDocked: mediaQueryList.matches, sidebarOpen: false })
  }

  /** Callback function triggered when the open state of the side bar is changed. Happens after sliding the sidebar and when the overlay is clicked when the sidebar is open. */
  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open })
  }
}

export default SaxsSideBar

SaxsSideBar.propTypes = {
  /** react component rendered in the side bar. */
  sideBarComponent: PropTypes.object.isRequired,
}
